module.exports.tagsJson = [{
  type: 'tags',
  id: 'de8e05f5-9db2-4917-88f9-098d2549c787',
  attributes: {
    value: 'climb',
    createdBy: 'Matt Hebden',
    createdDate: '2022-10-26T16:31:52.039Z',
  },
  links: {
    self: 'https://api2021.dyzio.co/v1/tags/de8e05f5-9db2-4917-88f9-098d2549c787',
  },
  relationships: {
    organisation: {
      meta: {
        relation: 'primary',
        readOnly: false,
      },
      links: {
        self: 'https://api2021.dyzio.co/v1/tags/de8e05f5-9db2-4917-88f9-098d2549c787/relationships/organisation',
        related: 'https://api2021.dyzio.co/v1/tags/de8e05f5-9db2-4917-88f9-098d2549c787/organisation',
      },
      data: {
        type: 'organisations',
        id: '0aff8cfc-4b27-4c18-9806-87cb83f2b01c',
      },
    },
  },
}, {
  type: 'tags',
  id: '1e19f4ec-878c-448e-8841-9914d34d9aef',
  attributes: {
    value: 'ride',
    createdBy: 'Matt Hebden',
    createdDate: '2022-10-26T16:31:52.039Z',
  },
  links: {
    self: 'https://api2021.dyzio.co/v1/tags/1e19f4ec-878c-448e-8841-9914d34d9aef',
  },
  relationships: {
    organisation: {
      meta: {
        relation: 'primary',
        readOnly: false,
      },
      links: {
        self: 'https://api2021.dyzio.co/v1/tags/1e19f4ec-878c-448e-8841-9914d34d9aef/relationships/organisation',
        related: 'https://api2021.dyzio.co/v1/tags/1e19f4ec-878c-448e-8841-9914d34d9aef/organisation',
      },
      data: {
        type: 'organisations',
        id: '0aff8cfc-4b27-4c18-9806-87cb83f2b01c',
      },
    },
  },
}, {
  type: 'tags',
  id: 'aa8a94c5-aaa3-48ab-a280-f107ecab802b',
  attributes: {
    value: 'fish',
    createdBy: 'Matt Hebden',
    createdDate: '2022-10-26T16:31:52.039Z',
  },
  links: {
    self: 'https://api2021.dyzio.co/v1/tags/aa8a94c5-aaa3-48ab-a280-f107ecab802b',
  },
  relationships: {
    organisation: {
      meta: {
        relation: 'primary',
        readOnly: false,
      },
      links: {
        self: 'https://api2021.dyzio.co/v1/tags/aa8a94c5-aaa3-48ab-a280-f107ecab802b/relationships/organisation',
        related: 'https://api2021.dyzio.co/v1/tags/aa8a94c5-aaa3-48ab-a280-f107ecab802b/organisation',
      },
      data: {
        type: 'organisations',
        id: '0aff8cfc-4b27-4c18-9806-87cb83f2b01c',
      },
    },
  },
}, {
  type: 'tags',
  id: 'f8558fb1-ab44-4755-93fe-bc9f26f083e7',
  attributes: {
    value: 'hike',
    createdBy: 'Matt Hebden',
    createdDate: '2022-10-26T16:31:52.039Z',
  },
  links: {
    self: 'https://api2021.dyzio.co/v1/tags/f8558fb1-ab44-4755-93fe-bc9f26f083e7',
  },
  relationships: {
    organisation: {
      meta: {
        relation: 'primary',
        readOnly: false,
      },
      links: {
        self: 'https://api2021.dyzio.co/v1/tags/f8558fb1-ab44-4755-93fe-bc9f26f083e7/relationships/organisation',
        related: 'https://api2021.dyzio.co/v1/tags/f8558fb1-ab44-4755-93fe-bc9f26f083e7/organisation',
      },
      data: {
        type: 'organisations',
        id: '0aff8cfc-4b27-4c18-9806-87cb83f2b01c',
      },
    },
  },
}, {
  type: 'tags',
  id: 'b9b16222-ddf5-4b1a-800b-d9b6fe3afbda',
  attributes: {
    value: 'camp',
    createdBy: 'Matt Hebden',
    createdDate: '2022-10-26T16:31:52.039Z',
  },
  links: {
    self: 'https://api2021.dyzio.co/v1/tags/b9b16222-ddf5-4b1a-800b-d9b6fe3afbda',
  },
  relationships: {
    organisation: {
      meta: {
        relation: 'primary',
        readOnly: false,
      },
      links: {
        self: 'https://api2021.dyzio.co/v1/tags/b9b16222-ddf5-4b1a-800b-d9b6fe3afbda/relationships/organisation',
        related: 'https://api2021.dyzio.co/v1/tags/b9b16222-ddf5-4b1a-800b-d9b6fe3afbda/organisation',
      },
      data: {
        type: 'organisations',
        id: '0aff8cfc-4b27-4c18-9806-87cb83f2b01c',
      },
    },
  },
}, {
  type: 'tags',
  id: '241387db-252d-4b2b-8d24-593c038ec08a',
  attributes: {
    value: 'surf',
    createdBy: 'Matt Hebden',
    createdDate: '2022-10-26T16:31:52.039Z',
  },
  links: {
    self: 'https://api2021.dyzio.co/v1/tags/241387db-252d-4b2b-8d24-593c038ec08a',
  },
  relationships: {
    organisation: {
      meta: {
        relation: 'primary',
        readOnly: false,
      },
      links: {
        self: 'https://api2021.dyzio.co/v1/tags/241387db-252d-4b2b-8d24-593c038ec08a/relationships/organisation',
        related: 'https://api2021.dyzio.co/v1/tags/241387db-252d-4b2b-8d24-593c038ec08a/organisation',
      },
      data: {
        type: 'organisations',
        id: '0aff8cfc-4b27-4c18-9806-87cb83f2b01c',
      },
    },
  },
}, {
  type: 'tags',
  id: 'da5615df-26f2-4601-bb38-ee2a3718bc49',
  attributes: {
    value: 'snow',
    createdBy: 'Matt Hebden',
    createdDate: '2022-10-26T16:31:52.039Z',
  },
  links: {
    self: 'https://api2021.dyzio.co/v1/tags/da5615df-26f2-4601-bb38-ee2a3718bc49',
  },
  relationships: {
    organisation: {
      meta: {
        relation: 'primary',
        readOnly: false,
      },
      links: {
        self: 'https://api2021.dyzio.co/v1/tags/da5615df-26f2-4601-bb38-ee2a3718bc49/relationships/organisation',
        related: 'https://api2021.dyzio.co/v1/tags/da5615df-26f2-4601-bb38-ee2a3718bc49/organisation',
      },
      data: {
        type: 'organisations',
        id: '0aff8cfc-4b27-4c18-9806-87cb83f2b01c',
      },
    },
  },
}, {
  type: 'tags',
  id: '33dd9552-868d-4147-b314-5fc75a94e9db',
  attributes: {
    value: 'photos',
    createdBy: 'Matt Hebden',
    createdDate: '2022-10-26T16:31:52.039Z',
  },
  links: {
    self: 'https://api2021.dyzio.co/v1/tags/33dd9552-868d-4147-b314-5fc75a94e9db',
  },
  relationships: {
    organisation: {
      meta: {
        relation: 'primary',
        readOnly: false,
      },
      links: {
        self: 'https://api2021.dyzio.co/v1/tags/33dd9552-868d-4147-b314-5fc75a94e9db/relationships/organisation',
        related: 'https://api2021.dyzio.co/v1/tags/33dd9552-868d-4147-b314-5fc75a94e9db/organisation',
      },
      data: {
        type: 'organisations',
        id: '0aff8cfc-4b27-4c18-9806-87cb83f2b01c',
      },
    },
  },
}, {
  type: 'tags',
  id: '98ffa49d-0bcc-43fa-97b9-64522757813c',
  attributes: {
    value: 'motorsport',
    createdBy: 'Matt Hebden',
    createdDate: '2022-10-26T16:31:52.039Z',
  },
  links: {
    self: 'https://api2021.dyzio.co/v1/tags/98ffa49d-0bcc-43fa-97b9-64522757813c',
  },
  relationships: {
    organisation: {
      meta: {
        relation: 'primary',
        readOnly: false,
      },
      links: {
        self: 'https://api2021.dyzio.co/v1/tags/98ffa49d-0bcc-43fa-97b9-64522757813c/relationships/organisation',
        related: 'https://api2021.dyzio.co/v1/tags/98ffa49d-0bcc-43fa-97b9-64522757813c/organisation',
      },
      data: {
        type: 'organisations',
        id: '0aff8cfc-4b27-4c18-9806-87cb83f2b01c',
      },
    },
  },
}, {
  type: 'tags',
  id: '70bc01dc-2840-4b5c-90a2-4ecd363c1c13',
  attributes: {
    value: 'paddle',
    createdBy: 'Matt Hebden',
    createdDate: '2022-10-26T16:31:52.039Z',
  },
  links: {
    self: 'https://api2021.dyzio.co/v1/tags/70bc01dc-2840-4b5c-90a2-4ecd363c1c13',
  },
  relationships: {
    organisation: {
      meta: {
        relation: 'primary',
        readOnly: false,
      },
      links: {
        self: 'https://api2021.dyzio.co/v1/tags/70bc01dc-2840-4b5c-90a2-4ecd363c1c13/relationships/organisation',
        related: 'https://api2021.dyzio.co/v1/tags/70bc01dc-2840-4b5c-90a2-4ecd363c1c13/organisation',
      },
      data: {
        type: 'organisations',
        id: '0aff8cfc-4b27-4c18-9806-87cb83f2b01c',
      },
    },
  },
}, {
  type: 'tags',
  id: '8cdd6da7-d0fd-4de8-baba-fd2887573e97',
  attributes: {
    value: 'skate',
    createdBy: 'Matt Hebden',
    createdDate: '2022-10-26T16:31:52.039Z',
  },
  links: {
    self: 'https://api2021.dyzio.co/v1/tags/8cdd6da7-d0fd-4de8-baba-fd2887573e97',
  },
  relationships: {
    organisation: {
      meta: {
        relation: 'primary',
        readOnly: false,
      },
      links: {
        self: 'https://api2021.dyzio.co/v1/tags/8cdd6da7-d0fd-4de8-baba-fd2887573e97/relationships/organisation',
        related: 'https://api2021.dyzio.co/v1/tags/8cdd6da7-d0fd-4de8-baba-fd2887573e97/organisation',
      },
      data: {
        type: 'organisations',
        id: '0aff8cfc-4b27-4c18-9806-87cb83f2b01c',
      },
    },
  },
}, {
  type: 'tags',
  id: '8e6974ed-dfc1-4f76-a3f9-06fbf6e7a65e',
  attributes: {
    value: 'wake',
    createdBy: 'Matt Hebden',
    createdDate: '2022-10-26T16:31:52.039Z',
  },
  links: {
    self: 'https://api2021.dyzio.co/v1/tags/8e6974ed-dfc1-4f76-a3f9-06fbf6e7a65e',
  },
  relationships: {
    organisation: {
      meta: {
        relation: 'primary',
        readOnly: false,
      },
      links: {
        self: 'https://api2021.dyzio.co/v1/tags/8e6974ed-dfc1-4f76-a3f9-06fbf6e7a65e/relationships/organisation',
        related: 'https://api2021.dyzio.co/v1/tags/8e6974ed-dfc1-4f76-a3f9-06fbf6e7a65e/organisation',
      },
      data: {
        type: 'organisations',
        id: '0aff8cfc-4b27-4c18-9806-87cb83f2b01c',
      },
    },
  },
}, {
  type: 'tags',
  id: '0b1f520f-04d1-4cf3-9452-7d4705e60ea0',
  attributes: {
    value: 'yoga',
    createdBy: 'Matt Hebden',
    createdDate: '2022-10-26T16:31:52.039Z',
  },
  links: {
    self: 'https://api2021.dyzio.co/v1/tags/0b1f520f-04d1-4cf3-9452-7d4705e60ea0',
  },
  relationships: {
    organisation: {
      meta: {
        relation: 'primary',
        readOnly: false,
      },
      links: {
        self: 'https://api2021.dyzio.co/v1/tags/0b1f520f-04d1-4cf3-9452-7d4705e60ea0/relationships/organisation',
        related: 'https://api2021.dyzio.co/v1/tags/0b1f520f-04d1-4cf3-9452-7d4705e60ea0/organisation',
      },
      data: {
        type: 'organisations',
        id: '0aff8cfc-4b27-4c18-9806-87cb83f2b01c',
      },
    },
  },
}, {
  type: 'tags',
  id: 'd690580a-9507-4697-81d5-61ce2682b119',
  attributes: {
    value: 'travel',
    createdBy: 'Matt Hebden',
    createdDate: '2022-10-26T16:31:52.039Z',
  },
  links: {
    self: 'https://api2021.dyzio.co/v1/tags/d690580a-9507-4697-81d5-61ce2682b119',
  },
  relationships: {
    organisation: {
      meta: {
        relation: 'primary',
        readOnly: false,
      },
      links: {
        self: 'https://api2021.dyzio.co/v1/tags/d690580a-9507-4697-81d5-61ce2682b119/relationships/organisation',
        related: 'https://api2021.dyzio.co/v1/tags/d690580a-9507-4697-81d5-61ce2682b119/organisation',
      },
      data: {
        type: 'organisations',
        id: '0aff8cfc-4b27-4c18-9806-87cb83f2b01c',
      },
    },
  },
}, {
  type: 'tags',
  id: '638363f0-a624-40dc-b9ec-024518e587ee',
  attributes: {
    value: 'you didn\'t list my sport',
    createdBy: 'Matt Hebden',
    createdDate: '2022-10-26T16:31:52.039Z',
  },
  links: {
    self: 'https://api2021.dyzio.co/v1/tags/638363f0-a624-40dc-b9ec-024518e587ee',
  },
  relationships: {
    organisation: {
      meta: {
        relation: 'primary',
        readOnly: false,
      },
      links: {
        self: 'https://api2021.dyzio.co/v1/tags/638363f0-a624-40dc-b9ec-024518e587ee/relationships/organisation',
        related: 'https://api2021.dyzio.co/v1/tags/638363f0-a624-40dc-b9ec-024518e587ee/organisation',
      },
      data: {
        type: 'organisations',
        id: '0aff8cfc-4b27-4c18-9806-87cb83f2b01c',
      },
    },
  },
}, {
  type: 'tags',
  id: '25827d83-e4eb-4427-a995-67e32948acdf',
  attributes: {
    value: 'general sending',
    createdBy: 'Matt Hebden',
    createdDate: '2022-10-26T16:31:52.039Z',
  },
  links: {
    self: 'https://api2021.dyzio.co/v1/tags/25827d83-e4eb-4427-a995-67e32948acdf',
  },
  relationships: {
    organisation: {
      meta: {
        relation: 'primary',
        readOnly: false,
      },
      links: {
        self: 'https://api2021.dyzio.co/v1/tags/25827d83-e4eb-4427-a995-67e32948acdf/relationships/organisation',
        related: 'https://api2021.dyzio.co/v1/tags/25827d83-e4eb-4427-a995-67e32948acdf/organisation',
      },
      data: {
        type: 'organisations',
        id: '0aff8cfc-4b27-4c18-9806-87cb83f2b01c',
      },
    },
  },
}];



/** WEBPACK FOOTER **
 ** ./src/themes/theme/tags/sendy/tags.js
 **/